import { useTranslation } from 'react-i18next';

import logo from '../../../assets/plates/nav-logo.png';

// Rooted at "/" so they also work from the public pages (terms, reset password)
const NAV_LINKS = [
  { key: 'workouts', href: '/#treinos' },
  { key: 'diet', href: '/#dieta' },
  { key: 'alexa', href: '/#alexa' },
  { key: 'plans', href: '/#planos' },
];

export const LandingNav = ({ onLogin, onSignup }) => {
  const { t } = useTranslation();

  return (
    <header className="mt-nav">
      <a className="mt-nav__brand" href="/" aria-label={t('appName')}>
        <img className="mt-nav__logo" src={logo} alt="" />
        <span className="mt-nav__wordmark">{t('appName')}</span>
      </a>

      <nav aria-label={t('standalone.navigation')}>
        <ul className="mt-nav__links">
          {NAV_LINKS.map(({ key, href }) => (
            <li key={key}>
              <a className={`mt-nav__link mt-nav__link--${key}`} href={href}>
                {t(`pages.Home.landing.nav.${key}`)}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <div className="mt-nav__actions">
        <button type="button" className="mt-nav__login" onClick={onLogin}>
          {t('pages.Home.landing.nav.login')}
        </button>
        <button type="button" className="mt-btn mt-btn--primary mt-nav__cta" onClick={onSignup}>
          <span className="mt-nav__cta-long">{t('pages.Home.landing.nav.signup')}</span>
          <span className="mt-nav__cta-short">{t('pages.Home.landing.nav.signupShort')}</span>
        </button>
      </div>
    </header>
  );
};
